import { render, staticRenderFns } from "./TheTabs.vue?vue&type=template&id=4a9468bc&scoped=true"
import script from "./TheTabs.vue?vue&type=script&lang=js"
export * from "./TheTabs.vue?vue&type=script&lang=js"
import style0 from "./TheTabs.vue?vue&type=style&index=0&id=4a9468bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9468bc",
  null
  
)

export default component.exports